import type { ParcelInfo } from "../net/api";

export type CellState = "mine" | "taken" | "free";
export interface Cell { id: string; x: number; y: number; w: number; h: number; state: CellState }

/** Minimap cells in SVG space: x east, y = −z so north is up (spec 2d §4.7). */
export function townCells(parcels: readonly ParcelInfo[], myParcelId: string | null): Cell[] {
  return parcels.map((p) => ({
    id: p.id,
    x: p.bounds.min[0],
    y: -p.bounds.max[1],
    w: p.bounds.max[0] - p.bounds.min[0],
    h: p.bounds.max[1] - p.bounds.min[1],
    state: p.id === myParcelId ? "mine" : p.taken ? "taken" : "free",
  }));
}

/** A square viewBox centred on the plaza that frames every lot plus a margin (never smaller than ±50, the library and plaza). */
export function townViewBox(cells: readonly Cell[]): [number, number, number, number] {
  const half = cells.reduce((m, c) => Math.max(m, Math.abs(c.x), Math.abs(c.y), Math.abs(c.x + c.w), Math.abs(c.y + c.h)), 45) + 5;
  return [-half, -half, 2 * half, 2 * half];
}
